/** @jsxImportSource @emotion/react */
import React from "react";
import ReactModal from "react-modal";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { ModalContent } from "../../../general/ModalContent/ModalContent";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import RegionRestrictedImage from "../../../../img/region_restricted.svg?react";
import ChevronRight from "../../../../img/chevron_right.svg?react";
import { Text } from "../../../general/Text";
import { Button } from "../../../general/Button/Button";
import { MODAL_SELECTORS } from "../modalSelectors";
import { Link } from "react-router-dom";

export const RegionRestrictedModal: React.FC = props => {
  const modalSelector = GlobalStore.useState(s => s.modalSelector);
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <>
      <ReactModal
        isOpen={modalSelector === MODAL_SELECTORS.REGION_RESTRICTED}
        className={`react-modal`}
        style={{
          content: {
            margin: "0 auto",
            outline: "none",
          },
        }}
      >
        <ModalContentContainer>
          <ModalContent backgroundColor="alt">
            <ModalInnerContainer>
              <ModalMainContentContainer>
                <RegionRestrictedImage />
                <Text
                  textStyle="Title"
                  size="Medium"
                  textCss={css`
                    text-align: center;
                  `}
                >
                  Region Restriction
                </Text>
                <div
                  css={css`
                    padding: 0px 29px;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    align-self: stretch;
                    text-align: center;
                  `}
                >
                  <Text textStyle="Paragraph" size="Large">
                    We are unable to let you proceed at this time as it appears you are accessing
                    Bebop from the United States.
                  </Text>
                  <Link to="https://bebop.xyz/terms.pdf" target={"_blank"}>
                    <Text
                      textStyle="Paragraph"
                      size="Large"
                      color={theme.font.link.default}
                      textCss={css`
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-top: 4px;
                        :hover {
                          color: white;
                        }
                        :hover path {
                          stroke: ${theme.button.primary.text.hover};
                          border: none;
                        }
                      `}
                    >
                      See our Terms & Conditions <ChevronRight />
                    </Text>
                  </Link>
                </div>
              </ModalMainContentContainer>
              <RegionRestrictedButton
                textSize="Large"
                buttonType={"primary"}
                text={"OK"}
                onClick={() => {
                  GlobalStore.update(s => {
                    s.modalSelector = undefined;
                  });
                }}
              />
            </ModalInnerContainer>
          </ModalContent>
        </ModalContentContainer>
      </ReactModal>
    </>
  );
};

// Sub-components

export const ModalContentContainer = styled.div`
  margin: auto;
  width: 367px;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const ModalMainContentContainer = styled.div`
  display: flex;
  padding: 10px 0px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const RegionRestrictedButton = styled(Button)`
  height: 56px;
  width: 100%;
  border-radius: 14px;
  border: none;
  text-align: center;
  justify-content: center;
  color: white;
`;
